export enum Permissions {

  Admin = 'ADMIN',

  ParameterKomponenteCreate = 'PARAMETER_KOMPONENTE_CREATE',
  ParameterKomponenteRead = 'PARAMETER_KOMPONENTE_READ',
  ParameterKomponenteUpdate = 'PARAMETER_KOMPONENTE_UPDATE',
  ParameterKomponenteDelete = 'PARAMETER_KOMPONENTE_DELETE',

  ParameterKomponenteRelease = 'PARAMETER_KOMPONENTE_RELEASE',
  ParameterKomponenteDownload = 'PARAMETER_KOMPONENTE_DOWNLOAD',


  ParameterCreate = 'PARAMETER_CREATE',
  ParameterRead = 'PARAMETER_READ',
  ParameterUpdate = 'PARAMETER_UPDATE',
  ParameterDelete = 'PARAMETER_DELETE',
  ParameterRelease = 'PARAMETER_RELEASE',
  ParameterDownload = 'PARAMETER_DOWNLOAD',


  RequestInfoEmail = 'REQUESTINFO_EMAIL',
  RequestInfoEmailNew = 'REQUESTINFO_EMAIL_NEW',
  RequestInfoEmailEdit = 'REQUESTINFO_EMAIL_EDIT',
  RequestInfoEmailView = 'REQUESTINFO_EMAIL_VIEW',
  RequestInfoEmailDelete = 'REQUESTINFO_EMAIL_DELETE',
  
  RequestInfoAnnotation = 'REQUESTINFO_ANNOTATION',
  RequestInfoSource = 'REQUESTINFO_SOURCE',
  RequestInfoSourceNew = 'REQUESTINFO_SOURCE_NEW',
  RequestInfoSourceEdit = 'REQUESTINFO_SOURCE_EDIT',
  RequestInfoSourceView = 'REQUESTINFO_SOURCE_VIEW',
  RequestInfoSourceDelete = 'REQUESTINFO_SOURCE_DELETE',

  FileUpload = 'FILE_UPLOAD',

  FileDownloadList = 'FILE_DOWNLOAD_LIST',
  FileDownloadTemplate = 'FILE_DOWNLOAD_TEMPLATE',
}
